import { ActionTree } from 'vuex'
import { ProductsState } from './state'
import {
  ProductsMutationTypes,
} from './mutations'
import { RootState } from '../../state'
import productsApiService from '@/services/products'
import type { CalculatePayload, BuySubscriptionPayload } from '@/models/billing'

export enum ProductsActionTypes {
  GetAll = '[Prodcuts Action] Get All',
  CalculateSubscription = '[Prodcuts Action] Calculate Subscription',
  BuySubscription = '[Products Action] Buy Subscription'
}


export const actions: ActionTree<ProductsState, RootState> = {
  async [ProductsActionTypes.GetAll](context) {
    const response = await productsApiService.getAllProducts()
    const payload = response
    context.commit(ProductsMutationTypes.GetAllProductsSuccess, payload)
    return response
  },

  async [ProductsActionTypes.CalculateSubscription](context, payload: CalculatePayload) {
    const response = await productsApiService.calculateSubscription(payload)
    const data = response.data
    context.commit(ProductsMutationTypes.CalculatePayloadSuccess, data)
  },

  async [ProductsActionTypes.BuySubscription](context, payload: BuySubscriptionPayload) {
    const response = await productsApiService.buySubscription(payload)
    const data = response.data
    context.commit(ProductsMutationTypes.BuyPayloadSuccess, data)
  }

}
